import React from 'react';
import { useAorText } from 'utils/aorTerminology';
import CropFreeOutlinedIcon from '@mui/icons-material/CropFreeOutlined';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import { StylishNewButton } from 'components/DesignSystems/New/StylishNewButton';
interface FirstSitrepPageProps {
  onClick: () => void;
}
export const FirstSitrepPage = ({ onClick }: FirstSitrepPageProps) => {
  const aorText = useAorText();
  return (
    <div className="sitrep-first-page">
      <h1>One Platform. Every Mission.</h1>
      <h4>
        Get started with setting up your first <b>PRATUS AI SITREP</b>
      </h4>
      <div className="d-flex flex-row gap-3">
        <StylishNewButton
          className="first-step-option"
          onClick={() => {
            //TODO: Navigate to AOR creation page
          }}
        >
          <CropFreeOutlinedIcon
            style={{ width: '150px', height: '150px', color: 'white' }}
          />
          <h4>{aorText('Select an AOR')}</h4>
          <div className="subtext">
            {aorText('If you havent created an AOR yet, create one')} <br />{' '}
            before you generate a PRATUS AI SITREP
          </div>
        </StylishNewButton>
        <StylishNewButton className="first-step-option" onClick={onClick}>
          <ArticleOutlinedIcon
            style={{ width: '150px', height: '150px', color: 'white' }}
          />
          <h4>Generate a PRATUS AI SITREP</h4>
          <div className="subtext">
            {aorText('If you already created an AOR, generate your')} <br />{' '}
            first PRATUS AI SITREP now.
          </div>
        </StylishNewButton>
      </div>
    </div>
  );
};
